import { useState, useEffect } from "react";
import API from "../services/api";
import { useNavigate } from "react-router-dom";
import { useCallback } from "react";
import { useLocation } from "react-router-dom";

function AddressModel() {

    const [addresses, setAddresses] = useState([]);
    const [ selectedId, setSelectedId ] = useState(null)
    const navigate = useNavigate();
    const location = useLocation();
    const from = location.state?.from

    const fetchAddresses = useCallback( async () => {
        try {
            const res = await API.get("/api/address/user/address");
            setAddresses(res.data)
        } catch (error) {
            console.error("Fetch address error:",error);
        }
    },[]);

    useEffect(() => {
        fetchAddresses();
        fetchSelected();
    }, [fetchAddresses]);


    const fetchSelected = async () => {
        try {
            const res = await API.get("/api/address/selected")
            setSelectedId(res.data?.addressId)
        } catch (error) {
            console.log(error)
        }
    }

    const handleDeliver = async (addr) => {
        try {
            await API.post(`/api/address/select?addressId=${addr.addressId}`);
        } catch (error) {
            console.log(error)
        }
        if (from === "checkout") {
            navigate("/checkout")
        } else if( from === "profile") {
            navigate("/profile")
        } else {
            navigate("/")
        }
    };

    const handleEdit = (addr) => {
        navigate("/update-address", { state: { address: addr } });
    };

    return (
        <div className="modal fade show d-block" tabIndex="-1">
            <div className="modal-dialog">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Choose your location</h5>
                        <button className="btn-close" onClick={() => navigate(-1)}></button>
                    </div>

                    <div className="modal-body">

                        {addresses.length === 0 ? (
                            <p>No address found</p>
                        ) : (
                            addresses.map((addr) => {


                                return (
                                    <div
                                        key={addr.addressId}
                                        className={`card mb-3 shadow-sm ${
                                            selectedId === addr.addressId
                                                ? "border-primary"
                                                : ""
                                        }`}
                                    >
                                        <div className="card-body">

                                            <h6 className="fw-bold">
                                                {addr.user?.name}
                                            </h6>

                                            <p className="mb-1">
                                                {addr.addressLine}, {addr.street}, {addr.city}
                                            </p>

                                            <p className="mb-2">
                                                {addr.state} - {addr.pincode}
                                            </p>

                                            <div className="d-flex gap-2">
                                                <button
                                                    className="btn btn-sm btn-outline-primary"
                                                    onClick={() => handleDeliver(addr)}
                                                >
                                                    Deliver Here
                                                </button>

                                                <button
                                                    className="btn btn-sm btn-outline-secondary"
                                                    onClick={() => handleEdit(addr)}
                                                >
                                                    Edit
                                                </button>
                                            </div>

                                        </div>
                                    </div>
                                );
                            })
                        )}

                        <button
                            className="btn btn-link"
                            onClick={() => navigate("/address")}
                        >
                            + Add new address
                        </button>

                    </div>

                </div>
            </div>
        </div>
    );
}

export default AddressModel;